export default "__VITE_ASSET__a40faf83__"